import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexGrow: 1,
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      width: 'calc(100% - 240px)',
      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%',
      },
    },
    appBarLarge: {
      width: `calc(100% - 73px)`,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%',
      },
    },
    large: {
      width: '100%',
    },
    visible: {
      display: 'flex',
    },
    hidden: {
      display: 'none',
    },
    newBgColor: {
      backgroundColor: '#12CDD9',
    },
    oldBgColor: {
      backgroundColor: 'transparent',
    },
    toolbar: theme.mixins.toolbar,
    colLeft: {
      flex: 1,
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    bdosLogo: {
      width: '8.5rem',
      marginLeft: 10,
    },
    userImage: {
      width: 48,
      height: 48,
      minWidth: 48,
      borderRadius: '50%',
      border: 'none',
    },
    colRight: {
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      color: '#333',
    },
    menu: {
      top: '55px !important',
    },
    containerInfosUser: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: 5,
      marginRight: 7,
      maxWidth: 250,
    },
    username: {
      fontSize: 14,
      fontWeight: 500,
      color: '#14171A',
    },
    textEllipsis: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    userEmail: {
      fontSize: 12,
      fontWeight: 'normal',
      color: '#14171A',
    },

    newTextColor: {
      color: '#fff',
    },
    oldTextColor: {
      color: '#14171A',
    },
    textColorWhite: {
      color: '#fff',
    },
    menuItemDisabled: {
      opacity: '1 !important',
    },
  }),
);

export default useStyles;
